module.exports = __webpack_public_path__ + "static/media/SebastianO.a23ec69d.jpg";